import React from "react";
import Section from "../Section";
import { NewsList } from "../../Data/NewsList";
import { delayNavigation } from "../../helpers/helpers";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const NewsSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Section bg="bg-inherit">
      <div className="col-span-10 col-start-2 text-primary-dark py-8">
        <div className="w-full flex items-center justify-start py-8 border-b-2 border-primary-dark/50 text-4xl xl:text-6xl tracking-widest font-gilroy">
          სიახლეები
        </div>
        <div className="w-full grid grid-cols-10 py-6">
          {NewsList.sort((a, b) => new Date(b.date) - new Date(a.date))
            .slice(0, 2)
            .map((news) => {
              return (
                <div
                  key={news.id}
                  className="col-span-full flex flex-col xl:flex-row items-center justify-between gap-6 py-8"
                >
                  <div className="w-full xl:w-1/2 h-96 flex items-start justify-center ">
                    <img
                      src={news.img}
                      alt="news"
                      className="w-full h-full xl:w-4/5 xl:h-4/5 object-cover"
                    />
                  </div>
                  <div className="w-full xl:w-1/2 h-full flex flex-col items-start justify-start gap-8 ">
                    <h2 className="text-3xl tracking-wide font-gilroy uppercase">
                      {news.header}
                    </h2>
                    <div className="flex items-center justify-start gap-3 text-sm font-bold">
                      <span className="px-3 py-1 bg-primary-orange text-primary-light rounded-lg">
                        {news.type}
                      </span>
                      <span className="text-primary-orange">{news.date}</span>
                    </div>
                    {/* <div
                      dangerouslySetInnerHTML={{
                        __html: news.text.slice(0, 255),
                      }}
                    /> */}
                    <p className="uppercase">{news.unstyledText}</p>
                    <a
                      href={`/news/${news.pathName}`}
                      onClick={(event) => {
                        delayNavigation(
                          dispatch,
                          navigate,
                          `/news/${news.pathName}`,
                          event
                        );
                      }}
                      className="relative text-primary-orange uppercase text-lg font-gilroy tracking-wider  bg-transparent no-underline opacity-100 transform transition-all duration-[0.45s] ease-out delay-[0.6s] flex flex-col justify-center items-center whitespace-nowrap cursor-pointer group"
                    >
                      დეტალურად ...
                      <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-orange transition-all duration-500 group-hover:w-full"></span>
                    </a>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Section>
  );
};

export default NewsSection;
